module.exports = __webpack_public_path__ + "img/homepage-pro-team.86ac547.jpg";